import { Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { JsonDataService } from '../../../shared/services/json-data.service';
import { MetaMgmtService } from '../../../shared/services/meta-mgmt.service';
import { UtilsService } from '../../../shared/services/utils.service';
import { CommonModule, DOCUMENT } from '@angular/common';
import { environment } from '../../../environments/environment';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { AddressService } from '../../../shared/services/address.service';
import { ProductDetailService } from '../../../shared/services/product-detail.service';
import { ProfileService } from '../../../shared/services/profile.service';
import { SchemaService } from '../../../shared/services/schema.service';
import { MatFormField } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { LimitNumberDirective } from '../../../shared/directives/limit-number.directive';
import { DomSanitizer } from '@angular/platform-browser';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-warranty-registration',
  standalone: true,
  imports: [CommonModule,MatFormField,MatSelectModule,ReactiveFormsModule,LimitNumberDirective,MatInputModule],
  templateUrl: './warranty-registration.component.html',
  styleUrl: './warranty-registration.component.scss'
})
export class WarrantyRegistrationComponent implements OnInit,OnDestroy {
  environment: any = environment;
  registerProductForm: any;
  featureImage: any;
  sub:Subscription=new Subscription()
  categoryList = [
    {
      "value": "inverter",
      "viewValue": "Inverter"
    },
    {
      "value": "battery",
      "viewValue": "Battery"
    },
    {
      "value": "solar",
      "viewValue": "Solar"
    },
    {
      "value": "stabilizer",
      "viewValue": "Stabilizer"
    }
  ];
  script:any;
  actualSchemaValue:any;
  constructor(  private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    private schemaService: SchemaService,public utils: UtilsService, private productService: ProductDetailService, private service: ProfileService, private fb: FormBuilder, private addressSvc: AddressService, private route: ActivatedRoute, private metaSvc: MetaMgmtService, private jsonDataService: JsonDataService, private router: Router) {
      this.sub.add(this.jsonDataService.getMetaDataJsonData().subscribe({
        next: (res: any) => {
          const activeRouter = this.utils.getActiveRouter(this.router.url);
          const metaDataFilter = res.find((x: any) => activeRouter === x.name);
          let metaData = {
            canonicalURL: metaDataFilter?.canonicalUrl || '',
            description: metaDataFilter?.description || '',
            pageTitle: metaDataFilter?.title || '',
          };
          this.metaSvc.updateMetaTags(metaData);
      },
      error: (err: any) => {
        console.error('Error fetching meta data', err);
      }}));
    this.utils.showHeaderFooter.next(true);
  }

  ngOnInit(): void {
    this.createRegisterProductForm();
    this.callSchema();

  }
  async callSchema(){
    this.actualSchemaValue = await this.schemaService.addSchema();
    this.script  = this._renderer2.createElement('script');
    this.script.type = `application/ld+json`;
    this.script.text = JSON.stringify(this.actualSchemaValue);
    this.script.defer = true;
    this._renderer2.appendChild(this._document.body, this.script);
  }
  createRegisterProductForm() {
    this.registerProductForm = this.fb.group({
      name: ['', [Validators.required, Validators.pattern(this.utils.nameRegex), Validators.minLength(2), Validators.maxLength(60)]],
      emailAddress: ['', [Validators.required, Validators.pattern(this.utils.emailRegex)]],
      phoneNumber: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10),]],
      streetAddress: ['', [Validators.required]],
      state: ['', [Validators.required]],
      city: ['', [Validators.required]],
      pincode: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
      category: ['', [Validators.required]],
      alphanumericCode: ['', [Validators.required, Validators.maxLength(14), Validators.pattern(this.utils.alphaNumericRegex)]],
      purchaseProofFileName: ['', [Validators.required]],
      purchaseProofFile: [null, [Validators.required]],
      purchaseProofContentType: ['', [Validators.required]]
    })
  }

  formSubmitted() {
    if (this.registerProductForm.valid) {
      this.utils.showLoading();
      this.sub.add( this.productService.addRegisterProduct(this.registerProductForm.value).subscribe({
        next: (res: any) => {
          if (res.success) {
            setTimeout(() => {
              this.utils.hideLoading();
              this.utils.openSnackBar('Thank you for sharing your details. Our team will contact you shortly.', 'success-toster');
            }, 100);
            this.registerProductForm.reset();
          }
          else {
            this.utils.hideLoading();
            this.utils.openSnackBar(res.message, 'error-toster');
          }
        }
      }))
    }
  }

  getPincodeDetails(event: any) {
    this.registerProductForm.get('state').reset();
    let pincode = event.target.value;
    if (pincode.length === 6 && this.registerProductForm.get('pincode').valid) {
      this.utils.showLoading();
      this.sub.add( this.addressSvc.getCityDataFromPinCode(this.registerProductForm.value.pincode.toString()).subscribe((data) => {
        this.utils.hideLoading();
        if (data.success) {
          if (data['masterResponseList'].length)
            this.registerProductForm.patchValue({
              state: data['masterResponseList'][0].stateName,
            })
        }
        else {
          this.utils.openSnackBar(data.message, 'error-toster')
        }
      }))
    }
  }

  formatBytes(bytes: number) {
    if (bytes === 0) return 0

    const k = 1024

    return Number(bytes / k)
  }

  async fileUpload(event: any) {
    if (event.target.files && event.target.files[0]) {
      this.featureImage = event.target.files[0] as File;
      let base64Img = await this.utils.getBase64FromFile(this.featureImage);
      if (this.formatBytes(this.featureImage.size) > 1024) {
        this.utils.openSnackBar(
          'File size should be less than 1 MB',
          'error-toster'
        );
        this.featureImage = '';
      } else if (
        this.featureImage.type == 'image/jpeg' ||
        this.featureImage.type == 'image/jpg' ||
        this.featureImage.type == 'image/png'
      ) {
        this.registerProductForm.controls['purchaseProofFile'].setValue(base64Img);
        this.registerProductForm.controls['purchaseProofFileName'].setValue(this.featureImage.name);
        this.registerProductForm.controls['purchaseProofContentType'].setValue(this.featureImage.type);
        this.featureImage = `data:${this.featureImage.type};base64,${base64Img}`;
      } else {
        this.utils.openSnackBar('Upload valid image format', 'error-toster');
        this.featureImage = '';
      }
      event.target.value = null;
    }
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.sub.unsubscribe()
  }

}
